module.exports = {
  "zones": {
    "Africa/Tripoli": ["z", {
      "wallclock": 1382666400000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 1382659200000,
      "save": 0
    }, {
      "wallclock": 1352512800000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 1352505600000,
      "save": 0,
      "rules": "Libya"
    }, {
      "wallclock": 875923200000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 875916000000,
      "save": 0
    }, {
      "wallclock": 844041600000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 844034400000,
      "save": 0,
      "rules": "Libya"
    }, {
      "wallclock": 641779200000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 641775600000,
      "save": 0
    }, {
      "wallclock": 378691200000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 378684000000,
      "save": 0,
      "rules": "Libya"
    }, {
      "wallclock": -347155200000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": -347158800000,
      "save": 0
    }, {
      "wallclock": -1577923200000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -1577926364000,
      "save": 0,
      "rules": "Libya"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 3164000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Libya": [{
      "from": 2013,
      "to": 2013,
      "month": 2,
      "day": [5, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 2013,
      "to": 2013,
      "month": 9,
      "day": [5, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1997,
      "to": 1997,
      "month": 3,
      "day": [7, 4],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1997,
      "to": 1997,
      "month": 9,
      "day": [7, 4],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1989,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1989,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1986,
      "month": 3,
      "day": [7, 4],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1986,
      "to": 1986,
      "month": 9,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1985,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1985,
      "month": 3,
      "day": [7, 6],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1982,
      "to": 1984,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1956,
      "to": 1956,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1955,
      "to": 1955,
      "month": 8,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1954,
      "to": 1954,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1953,
      "to": 1953,
      "month": 9,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1952,
      "to": 1952,
      "month": 0,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1951,
      "month": 9,
      "day": [7, 14],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }]
  }
};